/**
 * B3, the inbox (`MCK-20260521-009`).
 *
 * The empty states are four different sentences on purpose: *"nothing is assigned to you"* and
 * *"nobody has mentioned you"* are different pieces of news, and one generic *"nothing here"*
 * would make the tabs feel interchangeable when they are not.
 */

export const inboxEn = {
  'page.title': 'Inbox',
  'page.subtitle': 'Everything asking for you, across every project and every studio.',

  'tab.assigned': 'Assigned to me',
  'tab.review': 'Reviews awaiting me',
  'tab.mention': 'Mentions',
  'tab.following': 'Following',

  'scope.legend': 'Whose inbox',
  'scope.me': 'Mine',
  'scope.studio': 'The studio',
  'scope.others': 'Not mine',
  'action.onlyMine': 'You can read your people’s inbox. Marking it is theirs to do.',
  'filter.new': 'New only',
  'action.markAllRead': 'Mark all seen',
  'action.dismiss': 'Clear',
  'action.more': 'Show older',
  'action.loadingMore': 'Loading…',

  'action.markRead': 'Mark seen',
  'action.markUnread': 'Mark new',
  'action.open': 'Open it',
  'action.openOne': 'Open works on one row at a time.',
  'action.clearSelection': 'Clear the selection',
  'action.more2': 'More',
  'selection.count': '{count, plural, one {# item selected} other {# items selected}}',
  'panel.title': 'About this',
  'panel.close': 'Close',
  'panel.tab': 'Why you got it',
  'panel.when': 'Arrived',
  'panel.project': 'Project',
  'panel.studio': 'Studio',
  'keys.hint': '↑↓ move · Enter opens · r marks seen · x selects',
  'row.select': 'Select {title}',
  'row.new': 'New',
  'row.projectUnavailable': 'A project you can no longer open',

  'status.loading': 'Loading your inbox…',
  'empty.explains': 'Reviews, tasks and mentions that are waiting for you arrive here.',
  'empty.assigned.title': 'Nothing assigned',
  'empty.assigned': 'Nothing is assigned to you.',
  'empty.review_awaiting.title': 'No reviews waiting',
  'empty.review_awaiting': 'No review is waiting for your decision.',
  'empty.mention.title': 'No mentions',
  'empty.mention': 'Nobody has mentioned you.',
  'empty.following.title': 'Nothing new',
  'empty.following': 'Nothing has happened on what you follow.',
  'empty.new.title': 'All seen',
  'empty.new': 'Nothing new here.',

  'bell.new': '{count, plural, one {Inbox: # new} other {Inbox: # new}}',

  'error.load': 'Your inbox could not be loaded. Try again.',
  'error.mark': 'That did not save. Try again.',
} as const;

export type InboxMessageKey = keyof typeof inboxEn;
